// extracted by css-extract-rspack-plugin
export default {"TextAreaElementContainer":"TextAreaElement-module__TextAreaElementContainer__TjbdT7f","codeViewTextArea":"TextAreaElement-module__codeViewTextArea__Zz2cfem"};